import { createApi } from "@reduxjs/toolkit/query/react";
import { baseQuery } from "../baseQuery";

export const orderApi = createApi({
  reducerPath: "orderApi",
  baseQuery,
  tagTypes: ["tracking"],
  endpoints: (builder) => ({
    getOrderTrackingInfo: builder.query({
      query: (uuid) => `/order/track/${uuid}`,
      providesTags: ["tracking"],
    }),
  }),
});

export const { useLazyGetOrderTrackingInfoQuery } = orderApi;
